<div class="reset-page">
  <!-- Shop Branding -->
  <div class="title">
    <div class="logo">
      <img src="assets/logo.jpg" alt="Logo" />
    </div>
    <h1 class="brand-name">Sri Vigneshwara Jewellery</h1>
    <h2 class="brand-location">Pollachi</h2>
  </div>

  <!-- Reset Form -->
  <div class="reset-container">
    <h2>Reset Your Password / MPIN</h2>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <!-- Password Input -->
      <div class="form-group">
        <label for="password">New Password</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          placeholder="Enter new password"
        />
      </div>

      <p style="text-align:center; margin: 8px 0;">OR</p>

      <!-- MPIN Input -->
      <div class="form-group">
        <label for="mpin">New MPIN</label>
        <input
          type="password"
          id="mpin"
          formControlName="mpin"
          maxlength="6"
          placeholder="Enter new MPIN"
        />
      </div>

      <button type="submit" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Resetting...' : 'Reset' }}
      </button>
    </form>

    <!-- Always visible message -->
    <p class="message">{{ message }}</p>
  </div>
</div>
